/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Forgot_SubmitInputs */

const es_co2_password_forgot_submit = /** @type {(inputs: Password_Forgot_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar instrucciones`)
};

/**

* @param {Password_Forgot_SubmitInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const password_forgot_submit = /** @type {((inputs?: Password_Forgot_SubmitInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Forgot_SubmitInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_password_forgot_submit(inputs)
});